import styled from "styled-components";
import {
  whiteColor,
  screenSize,
  appFontColor,
  primaryColor,
  mediumFont,
  primaryHoverColor,
  regularFont,
  boldFont,
  newsecondaryColor,
  inputBorderColor,
  inputBackgroundColor,
  labelColor,
  semiBoldFont,
} from "@app/styles";

type Props = {
  disabled?: boolean;
  leftAlign?: boolean;
};

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
`;

export const SignInContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;
export const InnerContainer = styled.div`
  width: calc(100vw - 30px);
  position: relative;
  margin: 30px auto;
  overflow-x: hidden;
  padding: 60px 15px 15px;
  position: relative;
  // height: calc(100vh - 65px);
  // overflow-y: auto;
  @media (${screenSize.tablet}) {
    padding: 0px;
    width: 810px;
    height: 680px;
    display: flex;
    margin: 120px auto 40px;
    justify-content: flex-end;
    flex-direction: column;
    background: ${whiteColor};
    border: 1px solid #ccc;
    border-radius: 8px;
    input {
      border-color: #ccc;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  /* margin-bottom: 12px; */

  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    /* padding: 15px 15px 0; */
  }
`;
export const RowItem = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  @media (${screenSize.tablet}) {
    /* padding: 0 15px; */
    margin: 0;
  }
  .label {
    padding: 5px;
    font-weight: 500;
  }
  &.terms {
    align-items: center;
    flex-direction: row;
  }
  &.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  &.schoolCode_Input {
    input {
      border: 2px solid #13bd38;
    }
  }
`;
export const Heading = styled.div`
  color: ${appFontColor};
  text-align: center;
  padding: 15px;
  font-size: 21px;
  ${mediumFont};
  @media (${screenSize.tablet}) {
    border-bottom: 2px solid #dce0e8;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Footer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  @media (${screenSize.tablet}) {
    border-top: 1px solid #bdc3c7;
    padding: 0 20px;
    height: 90px;
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  .mar-c{
    margin-top:15px;
  }
`;
export const CancelButton = styled.div`
  display: none;
  margin-right: 15px;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Terms = styled.p`
  color: ${appFontColor};
  font-size: 13px;
  line-height: 26px;
  margin: 20px 0 0;
  padding: 20px 0;
  border-top: 1px solid #bdc3c7;
  a {
    font-size: inherit;
    color: ${primaryColor};
    text-decoration: none;
    ${mediumFont};
    &:hover {
      color: ${primaryHoverColor};
    }
  }
  @media (${screenSize.tablet}) {
    font-size: 14px;
    padding: 0 30px;
    border-top: 0;
    margin: 0px 0 30px;
  }
`;
export const Rule = styled.p`
  color: #424750;
  font-size: 13px;
  line-height: 17px;
  margin: 20px 0 0;
  padding: 0;
  display: flex;
  @media (${screenSize.tablet}) {
    padding: 0 30px;
    border-top: 0;
    margin: 10px 0;
    align-items: center;
  }
`;
export const Text = styled.p`
  color: ${appFontColor};
  text-align: center;
  a {
    font-size: inherit;
  }
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 12px;
  color: #dc3545;
  margin: 0;
  position: absolute;
  bottom: 8px;
  font-weight: normal;
  // bottom: -22px;
  // @media (${screenSize.tablet}) {
  //   bottom: 0;
  // }
`;
export const SavingIndicator = styled.div`
  opacity: 1;
  z-index: 9;
  svg {
    path {
      fill: ${whiteColor};
    }
  }
  @media (${screenSize.tablet}) {
    /* right:30px;
    right:auto;
    top:35px; */
    svg {
      path {
        fill: ${whiteColor};
      }
    }
  }
`;

export const RowSelectItem = styled.div`
  width: 100%;
  position: relative;
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  .label {
    padding: 5px;
    font-weight: 500;
  }
`;

export const FormHeadingCust = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height, or 122% */
  text-align: center;
  /* Text - Body */
  color: #33403e;
  padding-bottom: 20px;
  ${({ leftAlign }: Props) => {
    if (leftAlign) {
      return `
       text-align:left;
       padding-bottom: 12px;
    `;
    }
  }}
`;

export const SuccessContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &.student_success {
    margin-top: -30px;
    svg {
      width: 150px;
      height: 150px;
    }
  }
`;

export const SuccessHeading = styled.div`
  margin-top: 25px;
  font-size: 21px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.04em;
  color: #32bea6;
  ${regularFont};
`;
export const SuccessText = styled.div`
  margin: 10px 0;
  font-style: normal;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0.035em;
  color: #33403e;
  ${regularFont};
`;
export const SuccessButtonContainer = styled.div`
  margin-top: 25px;
  button {
    width: 330px;
    height: 50px;
  }
`;

export const EducatorSelectText = styled.h3`
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  ${mediumFont};
  color: #33403e;
  margin-top: 20px;
`;

export const EducatorFormContainer = styled.div`
  .educator-radio-grp {
  }
  .student-radio label {
    font-weight: 600;
    cursor: pointer;
    line-height: 26px;
    font-style: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #33403e;
    margin: 4px 0px;
  }
  span {
    display: block;
    padding-left: 30px;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.035em;
    color: #33403e;
    opacity: 0.8;
  }
`;

export const AccountBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 25px;
`;

export const Seperator = styled.div`
  margin: 16px 0px;
  height: 1px;
  background: #dfe3e9; ;
`;
export const ChangeText = styled.h3`
  font-style: normal;
  font-size: 14px;
  line-height: 28px;
  ${mediumFont};
  color: #00be9a;
  cursor: pointer;
`;
export const Label = styled.div`
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #33403e;
  ${boldFont};
`;

export const ChangeContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
export const ChangeDialogText = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.035em;
  color: #33403e;
  margin:15px 50px;
`;
export const DialogButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
`;
export const OkButtonContainer = styled.div`
  button {
    padding: 12px 16px;
  }
`;
export const CancelButtonContainer = styled.div`
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #00be9a;
  ${boldFont};
  cursor: pointer;
  margin-right: 32px;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 25px 0px;
`;

export const ChangePasswordText = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
  display: block;
  align-items: center;
  text-align: right;
  letter-spacing: 0.035em;
  color: #00be9a;
  cursor: pointer;
  margin-bottom: 15px;
`;
export const ProfileSuccessText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #33403e;
  margin: 15px 0px 30px 0px;
`;

export const DropDownLabel = styled.label`
  font-family: "Filson";
  font-size: 0.8rem;
  ${mediumFont}
  line-height: 21px;
  margin-bottom: 2px;
  margin-bottom: 2px;
  font-style: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.03em;
  color: #33403e;
`;

export const AccountLabel = styled.label`
  font-style: normal;
  ${mediumFont};
  font-size: 14px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.035em;
  color: #33403e;
`;
export const AccountLink = styled.a`
  color: #00be9a;
  padding: 0 5px;
  text-decoration: none;
  font-style: normal;
  ${mediumFont};
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0.035em;
`;
export const TermsBox = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  padding-bottom: 20px;
`;
export const SignInBox = styled.div`
  padding-top: 10px;
`;

export const SubBox = styled.div`
  border: 1.5px solid #00be9a;
  border-radius: 8px;
  background: #f9fcff;
  padding: 10px;
`;
export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ThankyouContainer = styled.div`
  width: 400px;
  padding: 48px 24px;
  display: flex;
  align-items: center;
`;

export const ThankyouImageContainer = styled.div``;

export const ThankyouText = styled.p`
  font-family: "Filson";
  font-size: 18px;
  ${mediumFont};
  line-height: 1.5;
  padding: 0 24px 0 32px;
`;

export const CenteredText = styled.p`
font-size: 14px;
${regularFont};
text-align: center;
color: ${labelColor};
margin: 0 0 16px;
&.m-0{
  margin: 0;
}
.phone{
  color: ${newsecondaryColor};
  @media (max-width: 575px){
    display: block;
  }
}

`

export const OTPTimer = styled.span`
display: flex;
align-items: center;
justify-content: center;
font-size: 14px;
${mediumFont};
color: ${labelColor};
text-align: center;
margin: 16px 0 32px;
span{
  font-size: 18px;
  color: ${newsecondaryColor};
  letter-spacing: 1.25px;
  margin-left: 4px;
}
`

export const ButtonHolder = styled.div`
width: 300px;
margin: 0 auto;
&:not(:last-of-type){
  margin-bottom: 16px;
}
&.disabled{
  cursor: not-allowed !important;
  opacity: 0.5;
  button{
    pointer-events: none;    
  }
}
`